<template>
  <div class="mb-3">
    <div class="bubble white large mb-2" :class="{ 'selected': selected }">
      <div class="inner full">
        <div class="flex-fill">
          <h2 class="mb-2 span">{{ subscriptionOption.displayName }}</h2>
          <span class="sale-badge" v-if="subscriptionOption?.discountPercentage">{{ (subscriptionOption.discountPercentage * 100) }}% off</span>
          <span class="sale-badge" v-if="subscriptionOption?.discountAmount && subscriptionOption.isUsageBased">Save {{ (formatSubscriptionCost(subscriptionOption.discountAmount)) }} off each bill</span>
          <span class="sale-badge" v-if="subscriptionOption?.discountAmount && !subscriptionOption.isUsageBased">{{ (formatSubscriptionCost(subscriptionOption.discountAmount)) }} off</span>
          
          <div>
            <p class="pt9-em mb-0">{{ subscriptionOption?.description }}</p>
          </div>
        </div>

        <div class="right-align subscription-promo-price">
          <h2 class="mb-0">
            {{ formatSubscriptionCost(subscriptionOption.totalCost) }}/{{ (subscriptionOption?.isMonthly ? "month" : "year") }}
            {{ (subscriptionOption?.isUsageBased ? " (per org.)" : "") }}
            {{ (subscriptionChanges ? "*" : "") }}
          </h2>
          <p class="pt9-em mb-0">Price includes GST</p>

          <p class="disclaimer mb-0 mt-3" v-if="subscriptionChanges">
            * {{ formatSubscriptionCost(subscriptionOption?.totalCost) }}/{{ (subscriptionOption?.isMonthly ? "month" : "year") }} {{ (subscriptionOption?.isUsageBased ? " (per org.)" : "") }}
            {{ disclaimerText }}
            {{ formatSubscriptionCost(subscriptionOption?.nextBaseCost) }}/{{ (subscriptionOption?.nextIsMonthly ? "month" : "year") }} {{ (subscriptionOption?.nextIsUsageBased ? " (per org.)" : "") }}
          </p>
        </div>
        
        <div v-if="!selected">
          <k-button
            class="btn btn-secondary btn-lg w-100"
            style="min-width: 100px;"
            type="button"
            @click="$emit('onSelect', subscriptionOption)"
          >
            Select
          </k-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "subscription-option",
  props: {
    subscriptionOption: {
      type: Object,
      default: {}
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatSubscriptionCost(price) {
      var currency = "AUD";

      const formatter = new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      const formattedPrice = formatter.format(price);
      return formattedPrice + " " + currency;
    }
  },
  computed: {
    subscriptionChanges() {
      return (this.subscriptionOption?.totalCost != this.subscriptionOption?.nextBaseCost)
        || (this.subscriptionOption?.isMonthly != this.subscriptionOption?.nextIsMonthly)
        || (this.subscriptionOption?.isUsageBased != this.subscriptionOption?.nextIsUsageBased)
    },
    disclaimerText() {
      if (this.subscriptionOption?.discountDuration == 'once') {
        return "includes initial payment only, then";
      }
      else if (this.subscriptionOption?.discountDuration == 'repeating') {
        return "for the first " + this.subscriptionOption.discountMonths + " months, then";
      }
      else {
        return "includes initial payment only, then";
      }
    }
  }
};
</script>
